(function () {
  function toArray(list) {
    return Array.prototype.slice.call(list || []);
  }

  function elementMatches(element, selector) {
    if (!element || element.nodeType !== 1) return false;
    var matcher = element.matches || element.webkitMatchesSelector || element.msMatchesSelector;
    return matcher ? matcher.call(element, selector) : false;
  }

  function closestElement(element, selector, boundary) {
    var current = element && element.nodeType === 1 ? element : element && element.parentElement;
    while (current) {
      if (elementMatches(current, selector)) return current;
      if (boundary && current === boundary) break;
      current = current.parentElement;
    }
    return null;
  }

  function directSummary(item) {
    var children = item ? item.children : [];
    for (var i = 0; i < children.length; i += 1) {
      if (children[i].tagName === 'SUMMARY') return children[i];
    }
    return null;
  }

  function initNavigation(root) {
    if (!root || root.getAttribute('data-core-navigation-ready') === 'true') return;
    root.setAttribute('data-core-navigation-ready', 'true');

    var desktop = window.matchMedia('(min-width: 1121px)');
    var items = toArray(root.querySelectorAll('.pw-nav__desktop [data-core-nav-item]'));
    var openTimer = 0;
    var closeTimer = 0;

    function clearTimers() {
      window.clearTimeout(openTimer);
      window.clearTimeout(closeTimer);
    }

    function closeAll(except) {
      for (var i = 0; i < items.length; i += 1) {
        if (items[i] !== except) items[i].open = false;
      }
    }

    function openItem(item, immediate) {
      if (!desktop.matches) return;
      clearTimers();
      var apply = function () {
        closeAll(item);
        item.open = true;
      };
      if (immediate) apply();
      else openTimer = window.setTimeout(apply, 90);
    }

    function closeItem(item) {
      if (!desktop.matches) return;
      clearTimers();
      closeTimer = window.setTimeout(function () {
        var hovered = elementMatches(item, ':hover');
        var focused = document.activeElement && item.contains(document.activeElement);
        if (!hovered && !focused) item.open = false;
      }, 180);
    }

    function activatePanel(item, panelId, focusTab) {
      var tabs = toArray(item.querySelectorAll('[data-core-nav-tab]'));
      var panels = toArray(item.querySelectorAll('[data-core-nav-panel]'));

      for (var i = 0; i < tabs.length; i += 1) {
        var activeTab = tabs[i].getAttribute('data-core-nav-tab') === panelId;
        tabs[i].classList.toggle('is-active', activeTab);
        tabs[i].setAttribute('aria-selected', activeTab ? 'true' : 'false');
        tabs[i].tabIndex = activeTab ? 0 : -1;
        if (activeTab && focusTab) tabs[i].focus();
      }

      for (var j = 0; j < panels.length; j += 1) {
        var activePanel = panels[j].getAttribute('data-core-nav-panel') === panelId;
        panels[j].classList.toggle('is-active', activePanel);
        panels[j].hidden = !activePanel;
      }
    }

    for (var itemIndex = 0; itemIndex < items.length; itemIndex += 1) {
      (function (item) {
        var summary = directSummary(item);
        var tabs = toArray(item.querySelectorAll('[data-core-nav-tab]'));

        item.addEventListener('toggle', function () {
          if (item.open) closeAll(item);
        });
        item.addEventListener('mouseenter', function () {
          openItem(item, false);
        });
        item.addEventListener('mouseleave', function () {
          closeItem(item);
        });
        item.addEventListener('focusin', function (event) {
          if (event.target === summary) return;
          openItem(item, true);
        });
        item.addEventListener('focusout', function () {
          closeItem(item);
        });

        if (summary) {
          summary.addEventListener('click', function (event) {
            if (!desktop.matches) return;
            event.preventDefault();
            if (item.open) item.open = false;
            else openItem(item, true);
          });
        }

        for (var tabIndex = 0; tabIndex < tabs.length; tabIndex += 1) {
          (function (tab, index) {
            var select = function () {
              activatePanel(item, tab.getAttribute('data-core-nav-tab'), false);
            };
            tab.addEventListener('mouseenter', select);
            tab.addEventListener('focus', select);
            tab.addEventListener('click', select);
            tab.addEventListener('keydown', function (event) {
              var next = null;
              if (event.key === 'ArrowDown') next = (index + 1) % tabs.length;
              if (event.key === 'ArrowUp') next = (index - 1 + tabs.length) % tabs.length;
              if (event.key === 'Home') next = 0;
              if (event.key === 'End') next = tabs.length - 1;
              if (next === null) return;
              event.preventDefault();
              activatePanel(item, tabs[next].getAttribute('data-core-nav-tab'), true);
            });
          })(tabs[tabIndex], tabIndex);
        }
      })(items[itemIndex]);
    }

    root.addEventListener('click', function (event) {
      if (desktop.matches && closestElement(event.target, 'a', root)) closeAll();
    });

    document.addEventListener('click', function (event) {
      if (!root.contains(event.target)) closeAll();
    });

    document.addEventListener('keydown', function (event) {
      if (event.key !== 'Escape') return;
      var active = null;
      for (var i = 0; i < items.length; i += 1) {
        if (items[i].open) {
          active = items[i];
          break;
        }
      }
      closeAll();
      if (active) {
        var activeSummary = directSummary(active);
        if (activeSummary && activeSummary.focus) {
          try {
            activeSummary.focus({ preventScroll: true });
          } catch (error) {
            activeSummary.focus();
          }
        }
      }
    });

    function mediaChanged() {
      clearTimers();
      closeAll();
      var mobileDetails = toArray(root.querySelectorAll('.pw-nav__mobile-label, .pw-nav__list--mobile details'));
      for (var i = 0; i < mobileDetails.length; i += 1) mobileDetails[i].open = false;
    }

    if (desktop.addEventListener) desktop.addEventListener('change', mediaChanged);
    else if (desktop.addListener) desktop.addListener(mediaChanged);
  }

  function initAll() {
    var roots = toArray(document.querySelectorAll('[data-core-navigation]'));
    for (var i = 0; i < roots.length; i += 1) initNavigation(roots[i]);
  }

  if (document.readyState === 'loading') {
    var onReady = function () {
      document.removeEventListener('DOMContentLoaded', onReady);
      initAll();
    };
    document.addEventListener('DOMContentLoaded', onReady);
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', initAll);
})();
